export default "__VITE_ASSET__DhNeyDXY__"